/*global __CLIENT__*/
import PropTypes from 'prop-types';

import React, { Component } from 'react';

// import './CreateProjectButton.css';

export default class DropdownBox extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
  };

  state = {
    partition: null,
    dropdownClosed: true,
  };

  onDropdownOptionClick(dropdownOption) {
    const { onClick } = this.props;

    onClick(dropdownOption);
    this.setState({ dropdownClosed: true });
  }

  mouseLeaveEvent = () => {
    this.setState({ dropdownClosed: true });
  }

  toggleDropdownState = () => {
    this.setState({ dropdownClosed: !this.state.dropdownClosed });
  }

  renderDropdownOptions() {
    const { dropdownOptions } = this.props;

    const output = [];

    dropdownOptions.forEach((v, k) => {
      output.push(
        <a
          key={k}
          className="dropdown-item"
          onClick={::this.onDropdownOptionClick.bind(this, v.labelKey)}
        >
          {v.label}
        </a>,
      );
    });

    return output;
  }

  render() {
    const { selectedSort } = this.props;

    let dropdownState = this.state.dropdownClosed
      ? 'dropdown'
      : 'dropdown show';

    const sortTypeMap = {
      ascending: 'A ➙ Z',
      elementType: 'Type',
      descending: 'Z ➙ A',
      date: 'Newest First',
    };

    return (
      <div
        className={dropdownState}
        style={{ display: 'block', marginTop: 5, marginBottom: 5 }}
      >
        <button
          onClick={this.toggleDropdownState}
          className="btn btn-outline-secondary dropdown-toggle"
          type="button"
          id="dropdownMenu2"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {selectedSort ? sortTypeMap[selectedSort] : 'Sort By'}
        </button>
        <div
          className="dropdown-menu"
          onMouseLeave={this.mouseLeaveEvent}
          aria-labelledby="dropdownMenu1"
        >
          {::this.renderDropdownOptions()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/inputs/DropdownBox.js